module.exports = __webpack_public_path__ + "static/media/new2.6ba3e73f.jpg";